import React from "react";

const Night = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M13.5 2C7.344 4.471 3 10.426 3 17.388 3 26.562 10.536 34 19.838 34A16.901 16.901 0 0 0 33.4 27.237a17.04 17.04 0 0 1-6.35 1.225c-9.301 0-16.838-7.438-16.838-16.612 0-3.689 1.225-7.093 3.288-9.85Zm6.138 4.713-1.113 2.112-2.487.338 1.8 1.637-.425 2.313 2.225-1.088 2.225 1.088-.424-2.313 1.8-1.637-2.488-.338-1.112-2.112h-.001Zm5.562 9.45L23.838 18.8l-3.038.425 2.2 2.05-.525 2.888L25.2 22.8l2.713 1.363-.513-2.888 2.2-2.05-3.037-.425-1.363-2.638Z"
            fill={fill}
        />
    </svg>
);

export default Night;
